import { render, staticRenderFns } from "./RevShareContentOverview.vue?vue&type=template&id=a8d352c6&scoped=true&"
import script from "./RevShareContentOverview.vue?vue&type=script&lang=js&"
export * from "./RevShareContentOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8d352c6",
  null
  
)

export default component.exports